// ============================================================
//  i18n.js — Internacionalización (ES / EN)
//  Gestor de Concursos v2.0
//
//  Uso:
//    import { t, cambiarIdioma, idiomaActual } from './i18n.js';
//    t('dashboard.titulo')  →  "Mis Concursos" | "My Contests"
// ============================================================

// ── Diccionarios ─────────────────────────────────────────────

const TRADUCCIONES = {
    es: {
        // Login
        'login.subtitulo':          'Plataforma de concursos para radioaficionados',
        'login.descripcion':        'Gestiona participaciones en concursos: logs, certificados, resultados y archivos. Perfil público y Shack Virtual integrable en QRZ.',
        'login.instruccion.es':     'Inicia sesión para continuar',
        'login.btn':                'Ingresar con Google',
        'login.footer':             'Contest Manager v2.0.0 · by CX4DPG - URUGUAY',
        'login.tab.iniciar':        'Iniciar sesión',
        'login.tab.registrar':      'Registrarse',
        'login.label.nombre':       'Nombre completo',
        'login.label.email':        'Email',
        'login.label.contrasena':   'Contraseña',
        'login.placeholder.nombre': 'Tu nombre completo',
        'login.placeholder.email':  'Correo electrónico',
        'login.placeholder.contrasena': 'Contraseña',
        'login.btn.iniciar':        'Iniciar sesión',
        'login.btn.crear':          'Crear cuenta',
        'login.btn.recuperar':      '¿Olvidaste tu contraseña?',
        'login.btn.conectando':     'Conectando...',
        'login.btn.registrando':    'Registrando...',

        // Navbar / Notificaciones
        'navbar.perfil.title':      'Configuración',
        'navbar.ayuda.title':       'Centro de Ayuda',
        'navbar.btn.salir':         'Cerrar sesión',
        'notif.titulo':             'Notificaciones',
        'notif.marcar-leidas':      'Marcar todas leídas',

        // Dashboard
        'dashboard.titulo':         'Mis Concursos',
        'dashboard.stat.concursos': 'Concursos',
        'dashboard.stat.partic':    'Participaciones',
        'dashboard.btn.nuevo':      '+ Nuevo concurso',
        'dashboard.vacio.texto':    'Aún no tienes concursos registrados.',
        'dashboard.vacio.subtexto': 'Después podrás cargar logs, certificados y resultados, y mostrar tu actividad en tu perfil público.',
        'dashboard.vacio.btn':      'Registrar mi primer concurso',
        'dashboard.seccion.encurso':    '🔴 En curso',
        'dashboard.seccion.proximos':   '⏳ Próximos',
        'dashboard.seccion.finalizados':'✅ Finalizados',

        // Tarjetas
        'tarjeta.btn.editar':       'Editar',
        'tarjeta.btn.eliminar':     'Eliminar',
        'tarjeta.archivo.log':      '📄 Log',
        'tarjeta.archivo.conf':     '📬 Conf.',
        'tarjeta.archivo.res':      '📊 Result.',
        'tarjeta.archivo.cert':     '🏆 Cert.',
        'tarjeta.archivo.reg':      '📋 Reglas',
        'tarjeta.certificado.cargado':   '✅ Certificado cargado',
        'tarjeta.certificado.pendiente': '⏳ Certificado pendiente',

        // Modal concurso
        'modal.concurso.titulo.nuevo':      'Agregar concurso',
        'modal.concurso.titulo.editar':     'Editar concurso',
        'modal.concurso.campo.nombre':      'Nombre del concurso',
        'modal.concurso.campo.año':         'Año',
        'modal.concurso.campo.modo':        'Modo',
        'modal.concurso.campo.indicativo':  'Participé con',
        'modal.concurso.campo.fechainicio': 'Fecha inicio (UTC)',
        'modal.concurso.campo.fechafin':    'Fecha fin (UTC)',
        'modal.concurso.hint.utc':          'Ingresa la hora en UTC, sin ajuste de zona horaria local.',
        'modal.concurso.campo.web':         'Sitio web',
        'modal.concurso.campo.rawscore':    'Puntaje declarado',
        'modal.concurso.campo.finalscore':  'Puntaje final',
        'modal.concurso.hint.indicativo':   'Los indicativos se cargan desde tu perfil',
        'modal.concurso.select.vacio':      '— Seleccionar —',
        'modal.concurso.select.sinperfil':  '— Completa tu perfil primero —',
        'modal.concurso.btn.cancelar':      'Cancelar',
        'modal.concurso.btn.guardar':       'Guardar concurso',
        'modal.concurso.placeholder.nombre':'ej: CQ WW DX Contest',
        'modal.concurso.placeholder.web':   'https://cqww.com',

        // Modal confirmación
        'confirmacion.btn.si':      'Sí, eliminar',
        'confirmacion.btn.no':      'Cancelar',
        'confirmacion.eliminar.titulo':    '¿Eliminar "{nombre}" ({año})?',
        'confirmacion.eliminar.subtitulo': 'Esta acción no se puede deshacer.',

        // Modal Drive
        'drive.modal.titulo':       'Conectar Google Drive',
        'drive.modal.descripcion':  'Para subir y gestionar archivos (logs, confirmaciones, certificados), necesitas autorizar el acceso a tu Google Drive.',
        'drive.modal.nota':         '🔒 Usamos el scope drive.file: solo accedemos a los archivos que esta app crea. Tus archivos existentes en Drive están completamente protegidos — no podemos verlos ni modificarlos.',
        'drive.modal.btn.cancelar': 'Ahora no',
        'drive.modal.btn.autorizar':'Autorizar Drive',

        // Modal archivos
        'archivos.modal.titulo':    'Archivos',
        'archivos.cargando':        'Cargando...',
        'archivos.btn.subir':       '↑ Subir archivo',
        'archivos.footer.hint':     'PDF, JPG, JFIF, PNG, ADI, LOG, TXT, ZIP, CBR, XLS, XLSX',
        'archivos.shack-visible':   'Mostrar en Shack',
        'archivos.vacio':           'No hay archivos en esta carpeta.',
        'archivos.btn.ver':         'Ver',

        // Panel perfil
        'perfil.titulo':            'Configuración',
        'perfil.hint.google':       'Datos sincronizados desde Google',
        'perfil.seccion.radio':     '📡 Datos de radioaficionado',
        'perfil.campo.indicativoOp':'Indicativo operador',
        'perfil.campo.indicativosEspeciales':'Indicativos especiales',
        'perfil.campo.indicativosEspeciales.hint':'(separados por coma)',
        'perfil.campo.club':        'Club / sociedad',
        'perfil.campo.zonaCQ':      'Zona CQ',
        'perfil.campo.zonaITU':     'Zona ITU',
        'perfil.seccion.prefs':     '⚙️ Preferencias',
        'perfil.seccion.peligro':   '⚠️ Zona de peligro',
        'perfil.peligro.descripcion':'Eliminar tu cuenta borrará permanentemente todos tus concursos y archivos registrados. Esta acción no se puede deshacer.',
        'perfil.btn.eliminar':      'Eliminar mi cuenta',

        // Modal eliminar cuenta
        'cuentaelim.titulo':        'Eliminar cuenta',
        'cuentaelim.subtitulo':     'Esta acción eliminará todos tus concursos y datos de forma permanente. No se puede deshacer.',
        'cuentaelim.label':         'Escribe ELIMINAR para confirmar:',
        'cuentaelim.placeholder':   'ELIMINAR',
        'cuentaelim.btn.cancelar':  'Cancelar',
        'cuentaelim.btn.confirmar': 'Eliminar todo',
        'cuentaelim.palabra':       'ELIMINAR',

        // Toasts
        'toast.sesion.expirada':    'Sesión expirada. Vuelve a iniciar sesión.',
        'toast.concurso.actualizado':'Concurso actualizado: {nombre}',
        'toast.concurso.agregado':  'Concurso agregado: {nombre}',
        'toast.concurso.eliminado': 'Concurso eliminado: {nombre}',
        'toast.drive.carpetas.ok':  '📁 Carpetas creadas en Google Drive.',
        'toast.drive.carpetas.error':'No se pudieron crear las carpetas en Drive. Se crearán al subir el primer archivo.',
        'toast.drive.conectado':    '¡Drive conectado correctamente!',
        'toast.drive.error.conectar':'No se pudo conectar con Drive.',
        'toast.drive.error.autorizar':'Error al autorizar Drive.',
        'toast.drive.preparando':   'Preparando carpeta en Drive...',
        'toast.drive.subiendo':     'Subiendo archivo...',
        'toast.drive.subido':       'Archivo subido: {nombre}',
        'toast.drive.error.subir':  'Error al subir el archivo: {error}',
        'toast.drive.error.cargar': 'Error al cargar los archivos.',
        'toast.perfil.guardado':    'Perfil guardado correctamente.',
        'toast.perfil.error':       'No se pudo guardar el perfil.',
        'toast.cuenta.eliminada':   'Cuenta eliminada correctamente.',
        'toast.cuenta.error':       'Error al eliminar la cuenta. Intenta de nuevo.',

        // Etiquetas de tipo archivo
        'tipo.log.nombre':   'Log',           'tipo.log.icono':   '📄',
        'tipo.conf.nombre':  'Confirmaciones','tipo.conf.icono':  '📬',
        'tipo.res.nombre':   'Resultados',    'tipo.res.icono':   '📊',
        'tipo.cert.nombre':  'Certificados',  'tipo.cert.icono':  '🏆',
        'tipo.reg.nombre':   'Reglas',        'tipo.reg.icono':   '📋',
        'tipo.log.desc':  'Archivo de contactos del concurso: Cabrillo, ADIF, LOG, TXT, etc.',
        'tipo.conf.desc': 'Comprobante de recepción del log: correo, captura o archivo donde la organización confirma que recibió tu log correctamente.',
        'tipo.res.desc':  'Clasificación o resultados oficiales publicados por el organizador.',
        'tipo.cert.desc': 'Certificado o diploma que acredita tu participación o premio obtenido.',
        'tipo.reg.desc':  'Reglamento oficial del concurso para referencia.',

        // Buscador catálogo
        'catalogo.buscando':              'Buscando...',
        'catalogo.sin.resultados':        'No se encontró "{texto}" en el catálogo.',
        'catalogo.btn.solicitar':         'Solicitar que se agregue este concurso',

        // Modal solicitud
        'solicitud.titulo':               '➕ Solicitar nuevo concurso',
        'solicitud.descripcion':          'El concurso será revisado y agregado al catálogo por el administrador.',
        'solicitud.campo.nombre':         'Nombre del concurso',
        'solicitud.campo.web':            'Sitio web / Reglas',
        'solicitud.campo.modos':          'Modos',
        'solicitud.campo.bandas':         'Bandas',
        'solicitud.campo.descripcion':    'Descripción',
        'solicitud.placeholder.nombre':   'Ej: CQ World Wide DX Contest',
        'solicitud.placeholder.descripcion': 'Breve descripción del concurso...',
        'solicitud.modo.mixto':           'Mixto',
        'solicitud.bandas.todas':         'Todas',
        'solicitud.btn.cancelar':         'Cancelar',
        'solicitud.btn.enviar':           'Enviar solicitud',
        'solicitud.btn.enviando':         'Enviando...',
        'solicitud.toast.enviada':        'Solicitud enviada. El administrador la revisará.',
        'solicitud.toast.error':          'No se pudo enviar la solicitud. Intenta de nuevo.',
        'solicitud.error.nombre':         'El nombre es obligatorio.',
        'solicitud.error.web':            'Ingresa una URL válida.',
        'solicitud.error.modos':          'Ingresa al menos un modo.',

        // Selector de idioma
        'idioma.selector.label':    'Idioma',

        // Footer
        'footer.copyright':         '© 2026 Contest Manager · Desarrollado por CX4DPG - Uruguay · v2.0.0-beta',
        'footer.btn.sugerencia':    'Enviar sugerencia',
        'footer.btn.acercade':      'Acerca de',

        // Modal sugerencia
        'sugerencia.titulo':        '📧 Enviar sugerencia',
        'sugerencia.campo.tipo':    'Tipo',
        'sugerencia.tipo.sugerencia':'💡 Sugerencia',
        'sugerencia.tipo.bug':      '🐛 Bug',
        'sugerencia.tipo.otro':     '💬 Otro',
        'sugerencia.campo.mensaje': 'Mensaje',
        'sugerencia.placeholder':   'Describe tu sugerencia o el error encontrado...',
        'sugerencia.btn.cancelar':  'Cancelar',
        'sugerencia.btn.enviar':    '📧 Enviar',
        'sugerencia.error.vacio':   'El mensaje no puede estar vacío.',
        'sugerencia.toast.abriendo':'Abriendo cliente de mail...',

        // Modal acerca de
        'acercade.titulo':          '📋 Acerca de',
        'acercade.descripcion':     'Sistema de gestión para concursos de radioaficionados',
        'acercade.item1':           '🔧 Versión beta — en desarrollo activo',
        'acercade.item2':           '🐛 Si encuentras algún error, usa el botón 📧 para enviar sugerencias',
        'acercade.dev':             'Desarrollado por CX4DPG — Uruguay',
        'acercade.stack':           'Tecnologías: Firebase · Vite · JavaScript ES6',
        'acercade.copyright':       '© 2026 Todos los derechos reservados.',
        'acercade.btn.cerrar':      'Cerrar',

        // Comunes reutilizables
        'common.guardar':           'Guardar',
        'common.guardando':         'Guardando...',
        'common.cancelar':          'Cancelar',

        // Dashboard — texto vacío por sección
        'dashboard.seccion.vacia':  'Sin concursos en esta categoría.',

        // Tarjeta de concurso
        'tarjeta.btn.ver-sitio':    'Ver sitio ↗',

        // Tarjeta de perfil — edición inline
        'tarjeta.btn.editar-perfil':                'Editar perfil',
        'tarjeta.crop.titulo':                      'Recorta tu foto de perfil',
        'tarjeta.crop.confirmar':                   'Confirmar recorte',
        'tarjeta.placeholder.indicativo-op':        'Indicativo operador',
        'tarjeta.placeholder.indicativos-esp':      'Especiales (separados por coma)',
        'tarjeta.hint.indicativos-esp':             'Puedes agregar varios indicativos especiales separados por comas.',
        'tarjeta.select.sin-qrz':                   '— Sin QRZ —',
        'tarjeta.select.sin-clublog':               '— Sin ClubLog —',
        'tarjeta.select.sin-eqsl':                  '— Sin eQSL —',

        // Tarjeta de perfil — ámbitos de posición
        'tarjeta.ambito.local':         'URUGUAY',
        'tarjeta.ambito.regional':      'SUDAMÉRICA',
        'tarjeta.ambito.mundial':       'MUNDO',

        // Tarjeta de perfil — etiquetas meta
        'tarjeta.meta.club':            'Club',
        'tarjeta.meta.pais':            'País / DXCC',
        'tarjeta.meta.zona-cq':         'Zona CQ',
        'tarjeta.meta.zona-itu':        'Zona ITU',
        'tarjeta.meta.qth':             'QTH',
        'tarjeta.meta.grid':            'Grid',
        'tarjeta.meta.telefono':        'Teléfono',
        'tarjeta.meta.correo':          'Correo',
        'tarjeta.meta.enlaces':         'Enlaces',

        // Tarjeta de perfil — estadísticas
        'tarjeta.stats.titulo':         'Resumen de actividad',
        'tarjeta.stats.subtitulo':      'Vista rápida del operador en la plataforma',
        'tarjeta.stats.concursos':      'Concursos',
        'tarjeta.stats.participaciones':'Participaciones',
        'tarjeta.stats.mejores':        'Mejores posiciones',
        'tarjeta.stats.mejor-pais':     'Mejor país',
        'tarjeta.stats.mejor-continente':'Mejor continente',
        'tarjeta.stats.mejor-mundo':    'Mejor mundo',
        'tarjeta.stats.total-uno':      'concurso',
        'tarjeta.stats.total-varios':   'concursos',
        'tarjeta.stats.ver-mas-uno':    'Ver 1 concurso más',
        'tarjeta.stats.ver-mas-varios': 'Ver {n} concursos más',
        'tarjeta.stats.mostrar-menos':  'Mostrar menos',

        // Tarjeta de perfil — footer
        'tarjeta.footer.modo':          'Modo más usado:',
        'tarjeta.footer.concurso':      'Concurso más trabajado:',
        'tarjeta.footer.ultimo':        'Último concurso:',

        // Shack
        'dashboard.btn.shack':          '📻 Mi Shack',
        'dashboard.shack.titulo':       'Mi Shack Virtual',

        // Analizador Cabrillo
        'dashboard.btn.cabrillo':       '📊 Analizador Cabrillo',
        'dashboard.cabrillo.titulo':    'Analiza visualmente un log Cabrillo por banda, hora y destino.',
        'cabrillo.titulo':              'Analizador Cabrillo',
        'cabrillo.subtitulo':           'Analiza visualmente un log Cabrillo por banda, hora y destino.',
        'cabrillo.credito.dev':         '"Analizador Cabrillo" es una herramienta desarrollada por — XQ2OP (Tío Julio).',
        'cabrillo.credito.agradecimiento': 'Contest Manager agradece especialmente a XQ2OP — Tío Julio, por desarrollar esta herramienta y compartirla especialmente con nosotros para su incorporación a la plataforma.',
        'cabrillo.selector.titulo':     'Selecciona un concurso',
        'cabrillo.selector.leyenda':    'Solo se muestran concursos con un archivo compatible con el Analizador Cabrillo. Si un concurso no aparece, verifica que hayas subido su log en formato Cabrillo (.log, .cbr o .txt).',
        'cabrillo.selector.cargando':   'Cargando tus concursos…',
        'cabrillo.selector.vacio':      'No tenés concursos con un log Cabrillo cargado todavía en Contest Manager.',
        'cabrillo.selector.no-auth':    'Iniciá sesión en Contest Manager para ver tus concursos.',
        'cabrillo.selector.no-auth.login': 'Iniciar sesión',
        'cabrillo.selector.btn':        'Analizar',
        'cabrillo.selector.btn.cargando': 'Analizando…',
        'cabrillo.estado.cargando-log': 'Cargando log…',
        'cabrillo.estado.error':        'No se pudo cargar automáticamente este log.',
        'cabrillo.estado.inicial':      'Selecciona uno de tus concursos para comenzar el análisis.',

        // Modal concurso — sección posición
        'modal.concurso.campo.posicion':       'Posición',
        'modal.concurso.campo.opcional':       '(opcional)',
        'modal.concurso.posicion.local':       'Local',
        'modal.concurso.posicion.regional':    'Regional',
        'modal.concurso.posicion.mundial':     'Mundial',
        'modal.concurso.placeholder.puesto':   'Puesto',
        'modal.concurso.placeholder.pais':     'Seleccionar país...',
        'modal.concurso.placeholder.region':   'Seleccionar región...',

        // Modal concurso — errores de validación
        'modal.concurso.error.nombre':         'El nombre del concurso es obligatorio.',
        'modal.concurso.error.año':            'Ingresa un año válido (1990–2100).',
        'modal.concurso.error.modo':           'Seleccionar un modo.',
        'modal.concurso.error.indicativo':     'Seleccionar el indicativo con el que participaste.',
        'modal.concurso.error.fechainicio':    'La fecha de inicio es obligatoria.',
        'modal.concurso.error.fechafin':       'La fecha de fin es obligatoria.',
        'modal.concurso.error.fechaorden':     'La fecha de fin debe ser posterior al inicio.',
        'modal.concurso.error.url':            'Ingresa una URL válida (ej: https://cqww.com).',

        // Configuración — preferencias
        'perfil.campo.tema-oscuro':            'Tema oscuro',
        'perfil.seccion.almacenamiento':       'Almacenamiento',
        'perfil.storage.user.nombre':          'Mi Drive',
        'perfil.storage.user.sub':             'Google Drive personal',
        'perfil.storage.user.t1':              'Privacidad total — solo tú tienes acceso',
        'perfil.storage.user.t2':              'Requiere conectar tu cuenta de Google Drive',
        'perfil.storage.user.t3':              'Recomendado para archivos privados',
        'perfil.storage.managed.sub':          'Almacenamiento del sistema',
        'perfil.storage.managed.t1':           'Sin configuración — no requiere conectar tu Drive',
        'perfil.storage.managed.t2':           'Espacio limitado y sujeto a disponibilidad',
        'perfil.storage.managed.t3':           'No recomendado para archivos sensibles',
        'perfil.notif.activar':                'Activar notificaciones',
        'perfil.notif.inapp':                  'En la app',
        'perfil.notif.resultados-disp':        'Resultados disponibles',
        'perfil.notif.certificados-disp':      'Certificados disponibles',
        'perfil.notif.poremail':               'Por email',
        'perfil.sesion.cerrar':                'Cerrar sesión',
        'perfil.btn.reiniciar-onboarding':     'Volver a ver la guía',
        'perfil.admin.titulo':                 '⚙️ Administración',
        'perfil.admin.btn':                    'Panel de administración',
        'perfil.drive.conectado.texto':              '✓ Google Drive conectado — clic para desconectar',
        'perfil.drive.noconectado.texto':            '○ Google Drive no conectado — clic para conectar',
        'perfil.drive.desconectar.confirma.titulo':  '¿Desconectar Google Drive?',
        'perfil.drive.desconectar.confirma.subtitulo': 'Se revocará el acceso. Puedes volver a conectarlo cuando quieras.',
        'perfil.drive.desconectar.confirma.btn':       'Sí, desconectar',
        'perfil.error.almacenamiento':         'No se pudo guardar el almacenamiento.',

        // Shack — toolbar
        'shack.toolbar.elemento':              'Elemento',
        'shack.toolbar.encuadrar':             '🖼️ Encuadrar',
        'shack.toolbar.encuadrar.title':       'Editar marco y proporción del cuadro seleccionado',
        'shack.toolbar.add-map':               '+ Mapa',
        'shack.toolbar.pared':                 'Pared',
        'shack.toolbar.borrar':                'Borrar',
        'shack.toolbar.alinear':               'Alinear',
        'shack.toolbar.distribuir':            'Distribuir',
        'shack.toolbar.orden':                 'Orden',
        'shack.toolbar.frente':                'Frente',
        'shack.toolbar.fondo':                 'Fondo',
        'shack.toolbar.calibracion':           'Calibración',
        'shack.toolbar.guardar-cal':           'Guardar calibración',
        'shack.toolbar.vista':                 'Vista',
        'shack.toolbar.zoom-reset.title':      'Restablecer zoom (doble click en zona vacía)',
        'shack.toolbar.certs':                 'Certificados',
        'shack.toolbar.gestionar-certs':       '🎖 Visibles',
        'shack.toolbar.compartir':             'Compartir',
        'shack.toolbar.copiar-iframe':         '🔗 Copiar código QRZ',
        'shack.toolbar.copiar-iframe.title':   'Publicar Shack y copiar código de imagen estática para QRZ.com',
        'shack.toolbar.align-left.title':      'Alinear al borde izquierdo',
        'shack.toolbar.align-center-h.title':  'Centrar horizontalmente',
        'shack.toolbar.align-right.title':     'Alinear al borde derecho',
        'shack.toolbar.align-top.title':       'Alinear al borde superior',
        'shack.toolbar.align-middle.title':    'Centrar verticalmente',
        'shack.toolbar.align-bottom.title':    'Alinear al borde inferior',
        'shack.toolbar.distribute-h.title':    'Distribuir con espacio horizontal igual',
        'shack.toolbar.distribute-v.title':    'Distribuir con espacio vertical igual',
        'shack.toolbar.toggle-calib.title':    'Activar/desactivar cuadrícula de calibración',
        'shack.toast.iframe-copiado':          'Shack publicado. Código QRZ copiado.',
        'shack.toast.iframe-error-callsign':   'No se pudo detectar el indicativo.',
        'shack.toast.iframe-error-publicar':   'No se pudo publicar el Shack Virtual.',
        'shack.toast.iframe-error-clipboard':  'No se pudo copiar al portapapeles.',
        'shack.qrz.virtual-de':               'Shack Virtual de',
        'shack.qrz.cta':                      'Haz clic para abrir el Shack Virtual interactivo.',
        'shack.panel-certs.titulo':            'Certificados en Shack',

        'shack.panel-certs.vacio':             'Sin certificados disponibles.',
        'shack.panel-certs.error':             'Error al actualizar visibilidad.',

        // Shack — avisos y toasts
        'shack.error.cargar':                  'Error al cargar el shack.',
        'shack.aviso.pendientes':              'Tienes {n} certificado(s) sin encuadrar.',
        'shack.aviso.encuadrar':               '🖼️ Encuadrar ahora',
        'shack.aviso.omitir':                  'Omitir',
        'shack.toast.todos-encuadrados':       '¡Todos los cuadros encuadrados!',
        'shack.aviso.drive.texto':             'Los certificados necesitan acceso a Google Drive para mostrarse.',
        'shack.aviso.drive.autorizar':         'Autorizar Drive',
        'shack.aviso.drive.autorizando':       'Autorizando...',
        'shack.aviso.drive.reintentar':        'Reintentar',
        'shack.toast.seleccionar-item':        'Selecciona un certificado o mapa primero.',
        'shack.toast.cuadro-actualizado':      'Cuadro actualizado.',
        'shack.toast.mapa-existe':             'El mapa ya existe.',
        'shack.toast.mapa-agregado':           'Mapa agregado.',
        'shack.toast.cert-no-borrar':          'Los certificados no se borran del shack. Solo puedes moverlos.',
        'shack.toast.cert-borrado':            'Certificado eliminado definitivamente.',
        'shack.toast.cert-error-datos':        'No se puede eliminar: faltan datos del archivo.',
        'shack.toast.cert-error-storage':      'Error al eliminar del almacenamiento. El archivo no fue borrado.',
        'shack.toast.cert-error-firestore':    'Error al eliminar el registro. Verifica el estado del archivo.',

        // Encuadrador
        'encuadrador.titulo':                  '🖼️ Preparar cuadro',
        'encuadrador.toolbar.alinear':         'Alinear cert:',
        'encuadrador.toolbar.centrar-h':       'Centrar horizontalmente',
        'encuadrador.toolbar.centrar-v':       'Centrar verticalmente',
        'encuadrador.toolbar.centrar-hv':      'Centrar en el interior',
        'encuadrador.toolbar.ajustar':         'Ajustar al interior',
        'encuadrador.toolbar.quitar-crop':     'Quitar recorte',
        'encuadrador.marco.label':             'Marco',
        'encuadrador.proporcion.label':        'Proporción del cuadro',
        'encuadrador.btn.cancelar':            'Cancelar',
        'encuadrador.btn.guardar':             '✓ Guardar cuadro',
        'encuadrador.error.pdf':               'No se pudo previsualizar este PDF',
        'encuadrador.cargando':                'Cargando...',
        'encuadrador.modelo.negro':            'Negro',
        'encuadrador.modelo.madera':           'Madera',
        'encuadrador.aspecto.libre':           'Libre',

        // Vista pública — controles
        'tarjeta.vista-publica.titulo':       'Vista pública',
        'tarjeta.vista-publica.idioma':       'Idioma de la tarjeta',
        'tarjeta.vista-publica.tema':         'Tema de la tarjeta',
        'tarjeta.vista-publica.lang.es':      'Español',
        'tarjeta.vista-publica.lang.en':      'Inglés',
        'tarjeta.vista-publica.tema.light':   'Claro',
        'tarjeta.vista-publica.tema.dark':    'Oscuro',
        'tarjeta.vista-publica.ver':          'Ver tarjeta pública',
        'tarjeta.vista-publica.opciones':     'Opciones',

        // Tarjeta para QRZ
        'tarjeta.btn.copiar-iframe':    'Copiar tarjeta para QRZ',
        'tarjeta.iframe.aria-info':     'Información sobre la tarjeta de perfil para QRZ',
        'tarjeta.iframe.tooltip.p1':    'Este código muestra tu tarjeta de perfil de Contest Manager en otras páginas, como la sección Biography de QRZ u otros sitios web.',
        'tarjeta.iframe.tooltip.p2':    'Solo tienes que copiarlo y pegarlo donde quieras que aparezca tu tarjeta.',
        'tarjeta.iframe.tooltip.p3':    'La información se actualiza automáticamente cuando guardas cambios en Contest Manager.',
        'tarjeta.toast.iframe.copiado': 'Tarjeta copiada. Pégala en la sección Biography de QRZ. Los cambios se reflejan automáticamente.',
        'tarjeta.toast.iframe.error':   'No se pudo copiar el código.',

        // Botón onboarding
        'perfil.btn.reiniciar-onboarding': 'Volver a ver la guía',

        // Login — divisor
        'login.divisor.o':              'o',

        // Campos de perfil sin i18n previo
        'perfil.campo.pais':            'País / DXCC',
        'perfil.campo.qth':             'QTH',
        'perfil.campo.grid':            'Grid Locator',
        'perfil.campo.dxcc':            'DXCC',
        'perfil.campo.telefono':        'Teléfono',
        'perfil.campo.correo-contacto': 'Correo de contacto',
        'perfil.campo.qrz':             'QRZ',
        'perfil.mostrar-telefono':      'Mostrar teléfono públicamente',
        'perfil.mostrar-correo':        'Mostrar correo públicamente',

        // Shack spinner
        'shack.cargando-certificados':  'Cargando certificados...',

        // Shack guía rápida
        'shack.guia.titulo':            'Flujo básico:',
        'shack.guia.p1':               'Seleccionar certificado',
        'shack.guia.p2':               'Encuadrar si hace falta',
        'shack.guia.p3':               'Mover o ajustar posición',
        'shack.guia.p4':               'Guardar cambios',
        'shack.guia.p5':               'Copiar código para QRZ',
        'shack.guia.cerrar.aria':       'Cerrar guía',

        // Shack — confirmación de publicación
        'shack.confirma.publicar.titulo':    '¿Publicar Shack y copiar código para QRZ?',
        'shack.confirma.publicar.subtitulo': 'Las imágenes se subirán y tu Shack quedará visible en tu perfil público. Puedes actualizarlo cuando quieras.',
        'shack.confirma.publicar.btn':       'Sí, publicar',

        // Modal archivos — acciones sobre ítems
        'archivos.btn.preview':         'Vista previa',
        'archivos.btn.abrir':           'Abrir en Drive',
        'archivos.btn.eliminar-archivo':'Eliminar archivo',
        'archivos.confirmar.titulo':    '¿Eliminar este archivo?',
        'archivos.confirmar.subtitulo': 'Se borrará de Drive y del registro.',
        'archivos.toast.eliminado':     'Archivo eliminado correctamente.',

        // Modal drive — autorización
        'drive.autorizando':            'Autorizando...',
        'drive.subiendo':               'Subiendo...',
        'toast.drive.error.autorizar2': 'No se pudo autorizar Google Drive. Puedes volver a intentarlo.',
        'toast.drive.error.cargar2':    'No se pudieron cargar los archivos. Puedes volver a intentarlo.',
        'toast.drive.error.eliminar':   'No se pudo eliminar el archivo. Puedes volver a intentarlo.',
        'toast.drive.auth.requerida':   'Autoriza Google Drive antes de subir. Haz clic en "Autorizar Google Drive".',
        'toast.drive.sesion-requerida': 'Debes iniciar sesión para usar este almacenamiento.',

        // Errores de Drive por código
        'toast.drive.sesion-expirada':  'Tu sesión de Google Drive expiró. Vuelve a autorizar y luego reintenta.',
        'toast.drive.no-autorizado':    'Google Drive no está autorizado en esta sesión. Autorízalo para continuar.',
        'toast.drive.acceso-revocado':  'El acceso a Google Drive fue revocado. Debes autorizar nuevamente.',
        'toast.drive.sin-permisos':     'Faltan permisos de Google Drive para completar esta acción. Vuelve a autorizar e inténtalo otra vez.',
        'toast.drive.desconectado':          'Google Drive desconectado correctamente.',
        'toast.drive.error.desconectar':     'No se pudo desconectar Google Drive. Intenta de nuevo.',
        'toast.drive.error.generico':   'Ocurrió un error con Google Drive.',
        'toast.drive.error.fallback':   'Puedes volver a intentarlo.',

        // Perfil — modales de almacenamiento y cuenta
        'perfil.storage.labels.user':       'Mi Drive (Google Drive personal)',
        'perfil.storage.labels.managed':    'Contest Manager',
        'perfil.storage.cambio.descripcion':'Tienes archivos guardados en "{from}". Para cambiar a "{to}" es necesario que el administrador migre tus archivos primero.',
        'perfil.acceso-managed.enviado':    'Solicitud enviada. El administrador la revisará pronto.',
        'perfil.acceso-managed.error':      'No se pudo enviar la solicitud. Intenta de nuevo.',
        'perfil.acceso-managed.btn':        'Solicitar acceso',
        'perfil.cambio-storage.enviado':    'Solicitud de cambio enviada. El administrador la revisará pronto.',
        'perfil.cambio-storage.btn':        'Solicitar cambio',
        'perfil.eliminando':                'Eliminando...',
        'perfil.enviando':                  'Enviando...',
        'perfil.cuenta.subtitulo-drive':    'Esta acción eliminará tu cuenta, tu perfil, tus concursos, tu shack y la estructura de Google Drive creada por la app. Si algún recurso de Drive no puede borrarse, te lo informaremos claramente.',
        'perfil.cuenta.subtitulo-nodrive':  'Esta acción eliminará tu cuenta, tu perfil, tus concursos y tu shack. Los archivos de Google Drive creados por la app no se borrarán porque no hay autorización activa de Drive.',
        'perfil.cuenta.eliminada-drive-omitido': 'Cuenta eliminada. Los datos internos fueron borrados, pero los recursos de Google Drive no se eliminaron porque no había autorización activa.',
        'perfil.cuenta.eliminada-drive-errores': 'Cuenta eliminada. Los datos internos fueron borrados, pero algunos recursos de Google Drive no pudieron eliminarse.',
        'perfil.cuenta.relogin-requerido':  'Tus datos internos ya fueron procesados, pero Firebase exige que vuelvas a iniciar sesión antes de eliminar el acceso final de la cuenta.',

        // Progreso de eliminación de cuenta
        'perfil.cuenta.progreso.preparando':        'Preparando eliminación de cuenta...',
        'perfil.cuenta.progreso.drive-sin-auth':     'Datos internos eliminados. Los recursos de Drive no se borraron porque no había autorización activa.',
        'perfil.cuenta.progreso.drive-sin-recursos': 'No había recursos de Drive para eliminar.',
        'perfil.cuenta.progreso.eliminando-acceso':  'Eliminando acceso de la cuenta...',

        // Auth — mensajes de login/sesión
        'auth.recuperar.email-requerido':   'Ingresa tu email primero.',
        'auth.recuperar.enviado':           'Te enviamos un email para restablecer tu contraseña.',
        'auth.sesion.cerrada':              'Sesión cerrada correctamente.',
        'auth.sesion.error-cerrar':         'Error al cerrar sesión.',

        // Auth — errores de Firebase
        'auth.error.popup-cerrado':         'Cerraste la ventana antes de completar el inicio de sesión.',
        'auth.error.popup-bloqueado':       'El navegador bloqueó el popup. Permítelo e intenta de nuevo.',
        'auth.error.popup-cancelado':       'Se canceló la solicitud de inicio de sesión.',
        'auth.error.red':                   'Error de red. Verifica tu conexión.',
        'auth.error.muchos-intentos':       'Demasiados intentos. Espera unos minutos.',
        'auth.error.email-en-uso':          'Ya existe una cuenta con ese email.',
        'auth.error.email-invalido':        'El email no es válido.',
        'auth.error.contrasena-debil':      'La contraseña debe tener al menos 6 caracteres.',
        'auth.error.usuario-no-encontrado': 'No existe cuenta con ese email.',
        'auth.error.contrasena-incorrecta': 'Contraseña incorrecta.',
        'auth.error.credencial-invalida':   'Email o contraseña incorrectos.',
        'auth.error.generico':              'Error de autenticación:',

        // Centro de Ayuda
        'ayuda.titulo':             'Centro de Ayuda',
        'ayuda.subtitulo':          'Guías rápidas para usar Contest Manager y sus integraciones.',
        'ayuda.volver':             'Volver a la app',
        'ayuda.reiniciar-onboarding': 'Volver a ver guía primeros pasos',
        'ayuda.grupo.qrz':      'Integraciones con QRZ',
        'ayuda.a1.titulo':      'Cómo insertar mi tarjeta de perfil en QRZ',
        'ayuda.a1.p1':          'Ingresa a Contest Manager.',
        'ayuda.a1.p2':          'Verifica que tu perfil público esté completo.',
        'ayuda.a1.p3':          'En tu tarjeta de perfil, haz clic en "Copiar tarjeta para QRZ".',
        'ayuda.a1.p4':          'Ingresa a QRZ.com.',
        'ayuda.a1.p5':          'Abre Editar [tu indicativo] → Biography.',
        'ayuda.a1.p6':          'Pega el código copiado en el editor HTML.',
        'ayuda.a1.p7':          'Guarda los cambios.',
        'ayuda.a1.nota':        'Nota: La tarjeta de perfil se actualiza automáticamente cuando cambian tus datos o tus participaciones en Contest Manager.',
        'ayuda.a2.titulo':      'Cómo insertar mi Shack Virtual en QRZ',
        'ayuda.a2.intro':       'QRZ no permite ejecutar el Shack Virtual interactivo directamente dentro de la Biography porque no permite código externo en la página. Contest Manager genera en su lugar una imagen actualizable que al hacer clic abre el Shack interactivo completo.',
        'ayuda.a2.p1':          'Ingresa a Contest Manager.',
        'ayuda.a2.p2':          'Abre "Mi Shack Virtual".',
        'ayuda.a2.p3':          'Organiza tus certificados.',
        'ayuda.a2.p4':          'Haz clic en "Copiar código QRZ".',
        'ayuda.a2.p5':          'Ingresa a QRZ.com.',
        'ayuda.a2.p6':          'Abre Editar [tu indicativo] → Biography.',
        'ayuda.a2.p7':          'Pega el código copiado en el editor HTML.',
        'ayuda.a2.p8':          'Guarda los cambios.',
        'ayuda.a2.nota':        'Nota: La imagen del Shack en QRZ se actualiza automáticamente cuando modificas tu Shack Virtual. Al hacer clic sobre la imagen, se abre el Shack interactivo completo.',

        // Ayuda — sección 1: Primeros pasos
        'ayuda.s1.titulo':  'Primeros pasos',
        'ayuda.s1.texto':   'Comienza configurando tu cuenta, tu indicativo y tu perfil público.',
        'ayuda.s1.p1':      'Ingresa a Contest Manager.',
        'ayuda.s1.p2':      'Inicia sesión con tu cuenta.',
        'ayuda.s1.p3':      'Completa tu perfil con indicativo, nombre, país, grid y datos públicos.',
        'ayuda.s1.p4':      'Revisa la vista pública de tu perfil.',
        'ayuda.s1.p5':      'Comienza a registrar tus participaciones en concursos.',

        // Ayuda — sección 2: Perfil público
        'ayuda.s2.titulo':  'Perfil público',
        'ayuda.s2.texto':   'Tu perfil público muestra tu información principal como radioaficionado y un resumen de tu actividad.',
        'ayuda.s2.b1':      'Puedes mostrar tu indicativo, nombre, país, grid, zonas, club y enlaces externos.',
        'ayuda.s2.b2':      'Puedes decidir qué datos de contacto mostrar u ocultar.',
        'ayuda.s2.b3':      'La tarjeta pública se actualiza automáticamente cuando cambian tus datos o participaciones.',
        'ayuda.s2.b4':      'Puedes mostrar tu tarjeta de perfil en QRZ u otras páginas copiando el código desde tu panel de Contest Manager.',

        // Ayuda — sección 3: Concursos y archivos
        'ayuda.s3.titulo':  'Concursos y archivos',
        'ayuda.s3.texto':   'Contest Manager organiza tus participaciones y archivos por concurso, año y modo.',
        'ayuda.s3.b1':      'Registra cada participación indicando concurso, año, modo y fechas.',
        'ayuda.s3.b2':      'Sube archivos como logs, confirmaciones, resultados, certificados y reglas.',
        'ayuda.s3.b3':      'Algunos archivos pueden quedar pendientes de moderación antes de mostrarse públicamente.',
        'ayuda.s3.b4':      'Los concursos se organizan en En curso, Próximos y Finalizados.',
        'ayuda.s3.b5':      'Los concursos finalizados se ordenan mostrando primero los más recientes.',

        // Ayuda — sección 4: Shack Virtual
        'ayuda.s4.titulo':  'Shack Virtual',
        'ayuda.s4.texto':   'El Shack Virtual permite mostrar tus certificados dentro de una escena visual.',
        'ayuda.s4.b1':      'Puedes mover certificados, ajustar su ubicación y organizar tu pared virtual.',
        'ayuda.s4.b2':      'Usa la rueda del mouse para hacer zoom.',
        'ayuda.s4.b3':      'Arrastra con el botón izquierdo para moverte por la escena.',
        'ayuda.s4.b4':      'Haz doble clic sobre un certificado para verlo en detalle.',
        'ayuda.s4.b5':      'Si eliminas un certificado desde el Shack, se elimina definitivamente de Contest Manager y del almacenamiento asociado.',
        'ayuda.s4.b6':      'Los certificados visibles también aparecen en la versión pública de tu Shack Virtual.',

        // Ayuda — sección 6: Almacenamiento
        'ayuda.s6.titulo':  'Almacenamiento',
        'ayuda.s6.texto':   'Contest Manager puede trabajar con archivos guardados en tu Drive o con almacenamiento administrado por la plataforma.',
        'ayuda.s6.b1':      'En modo Drive propio, los archivos se guardan en tu cuenta de Google Drive.',
        'ayuda.s6.b2':      'En modo Almacenamiento CM, los archivos se guardan en el almacenamiento administrado de Contest Manager.',
        'ayuda.s6.b3':      'El acceso al Almacenamiento CM puede requerir aprobación del administrador.',
        'ayuda.s6.b4':      'Los archivos usados en QRZ o visibles públicamente pueden guardarse en el almacenamiento de la plataforma para que carguen correctamente.',
        'ayuda.s6.b5':      'No compartas archivos sensibles si no deseas que puedan mostrarse públicamente.',

        // Ayuda — sección 7: Notificaciones
        'ayuda.s7.titulo':  'Notificaciones',
        'ayuda.s7.texto':   'Contest Manager usa notificaciones dentro de la app y, en algunos casos, correos electrónicos.',
        'ayuda.s7.b1':      'Puedes recibir avisos cuando una solicitud es aprobada o rechazada.',
        'ayuda.s7.b2':      'El administrador puede recibir avisos de nuevas solicitudes.',
        'ayuda.s7.b3':      'Las notificaciones aparecen en la campanita de la barra superior.',
        'ayuda.s7.b4':      'Algunas acciones importantes también pueden enviarse por correo electrónico.',

        // Ayuda — sección 8: Preguntas frecuentes
        'ayuda.s8.titulo':  'Preguntas frecuentes',
        'ayuda.s8.q1':      '¿Por qué mi Shack no se ve interactivo dentro de QRZ?',
        'ayuda.s8.a1':      'Porque QRZ no permite código externo dentro de su página. Contest Manager usa en su lugar una imagen estática que al hacer clic abre el Shack interactivo completo.',
        'ayuda.s8.q2':      '¿La imagen del Shack en QRZ se actualiza sola?',
        'ayuda.s8.a2':      'Sí. Cuando modificas tu Shack Virtual, Contest Manager actualiza la imagen pública usada en QRZ.',
        'ayuda.s8.q3':      '¿Tengo que volver a copiar el código QRZ cada vez que cambio mi Shack?',
        'ayuda.s8.a3':      'No. Solo debes copiarlo nuevamente si quieres reemplazar el código en tu página de QRZ.',
        'ayuda.s8.q4':      '¿La tarjeta de perfil se actualiza sola?',
        'ayuda.s8.a4':      'Sí. La tarjeta toma los datos públicos y la actividad registrada en Contest Manager.',
        'ayuda.s8.q5':      '¿Mis archivos originales quedan públicos?',
        'ayuda.s8.a5':      'No necesariamente. Para QRZ se utiliza una imagen pública preparada para mostrar el Shack, no el archivo original de cada certificado.',
        'ayuda.s8.q6':      '¿Qué pasa si elimino un certificado desde el Shack?',
        'ayuda.s8.a6':      'El certificado se elimina definitivamente de Contest Manager, del Shack Virtual y del almacenamiento asociado. Esta acción no se puede deshacer.',

        // Primeros pasos
        'primeros-pasos.titulo':    '🚀 Primeros pasos',
        'primeros-pasos.cerrar':    'Cerrar',
        'primeros-pasos.p1.titulo': 'Completa tu perfil',
        'primeros-pasos.p1.desc':   'Agrega tu indicativo, zona CQ/ITU y datos de tu estación.',
        'primeros-pasos.p2.titulo': 'Elige tu almacenamiento',
        'primeros-pasos.p2.desc':   'Configura Google Drive propio o el almacenamiento de la plataforma.',
        'primeros-pasos.p3.titulo': 'Registra tu primer concurso',
        'primeros-pasos.p3.desc':   'Añade el nombre, fechas y modo operativo.',
        'primeros-pasos.p4.titulo': 'Sube tus archivos',
        'primeros-pasos.p4.desc':   'Después de registrar un concurso podrás adjuntar log, confirmación, resultados, certificado y reglamento.',
        'primeros-pasos.p5.titulo': 'Explora tu perfil público',
        'primeros-pasos.p5.desc':   'Abre tu página pública con tu indicativo, estadísticas y actividad en concursos.',
        'primeros-pasos.p6.titulo': 'Descubre el Shack Virtual',
        'primeros-pasos.p6.desc':   'Organiza y exhibe tus certificados en una escena 3D.',
    },

    en: {
        // Login
        'login.subtitulo':          'Amateur radio contest management platform',
        'login.descripcion':        'Manage contest entries: logs, certificates, results, and files. Public profile and Virtual Shack for QRZ.',
        'login.instruccion.es':     'Sign in to continue',
        'login.btn':                'Sign in with Google',
        'login.footer':             'Contest Manager v2.0.0 · by CX4DPG - URUGUAY',
        'login.tab.iniciar':        'Sign in',
        'login.tab.registrar':      'Sign up',
        'login.label.nombre':       'Full name',
        'login.label.email':        'Email',
        'login.label.contrasena':   'Password',
        'login.placeholder.nombre': 'Your full name',
        'login.placeholder.email':  'Email address',
        'login.placeholder.contrasena': 'Password',
        'login.btn.iniciar':        'Sign in',
        'login.btn.crear':          'Create account',
        'login.btn.recuperar':      'Forgot your password?',
        'login.btn.conectando':     'Connecting...',
        'login.btn.registrando':    'Registering...',

        // Navbar / Notificaciones
        'navbar.perfil.title':      'Settings',
        'navbar.ayuda.title':       'Help Center',
        'navbar.btn.salir':         'Sign out',
        'notif.titulo':             'Notifications',
        'notif.marcar-leidas':      'Mark all as read',

        // Dashboard
        'dashboard.titulo':         'My Contests',
        'dashboard.stat.concursos': 'Contests',
        'dashboard.stat.partic':    'Participations',
        'dashboard.btn.nuevo':      '+ New contest',
        'dashboard.vacio.texto':    'No contests registered yet.',
        'dashboard.vacio.subtexto': 'Once registered, you can upload logs, certificates and results, and share your activity on your public profile.',
        'dashboard.vacio.btn':      'Register my first contest',
        'dashboard.seccion.encurso':    '🔴 Active',
        'dashboard.seccion.proximos':   '⏳ Upcoming',
        'dashboard.seccion.finalizados':'✅ Finished',

        // Tarjetas
        'tarjeta.btn.editar':       'Edit',
        'tarjeta.btn.eliminar':     'Delete',
        'tarjeta.archivo.log':      '📄 Log',
        'tarjeta.archivo.conf':     '📬 QSL',
        'tarjeta.archivo.res':      '📊 Results',
        'tarjeta.archivo.cert':     '🏆 Cert.',
        'tarjeta.archivo.reg':      '📋 Rules',
        'tarjeta.certificado.cargado':   '✅ Certificate uploaded',
        'tarjeta.certificado.pendiente': '⏳ Certificate pending',

        // Modal concurso
        'modal.concurso.titulo.nuevo':      'Add contest',
        'modal.concurso.titulo.editar':     'Edit contest',
        'modal.concurso.campo.nombre':      'Contest name',
        'modal.concurso.campo.año':         'Year',
        'modal.concurso.campo.modo':        'Mode',
        'modal.concurso.campo.indicativo':  'Callsign used',
        'modal.concurso.campo.fechainicio': 'Start date (UTC)',
        'modal.concurso.campo.fechafin':    'End date (UTC)',
        'modal.concurso.hint.utc':          'Enter time in UTC — no local timezone adjustment.',
        'modal.concurso.campo.web':         'Website',
        'modal.concurso.campo.rawscore':    'Declared score',
        'modal.concurso.campo.finalscore':  'Final score',
        'modal.concurso.hint.indicativo':   'Callsigns are loaded from your profile',
        'modal.concurso.select.vacio':      '— Select —',
        'modal.concurso.select.sinperfil':  '— Complete your profile first —',
        'modal.concurso.btn.cancelar':      'Cancel',
        'modal.concurso.btn.guardar':       'Save contest',
        'modal.concurso.placeholder.nombre':'e.g.: CQ WW DX Contest',
        'modal.concurso.placeholder.web':   'https://cqww.com',

        // Modal confirmación
        'confirmacion.btn.si':      'Yes, delete',
        'confirmacion.btn.no':      'Cancel',
        'confirmacion.eliminar.titulo':    'Delete "{nombre}" ({año})?',
        'confirmacion.eliminar.subtitulo': 'This action cannot be undone.',

        // Modal Drive
        'drive.modal.titulo':       'Connect Google Drive',
        'drive.modal.descripcion':  'To upload and manage files (logs, confirmations, certificates), you need to authorize access to your Google Drive.',
        'drive.modal.nota':         '🔒 We use the drive.file scope: we only access files this app creates. Your existing Drive files are fully protected — we cannot view or modify them.',
        'drive.modal.btn.cancelar': 'Not now',
        'drive.modal.btn.autorizar':'Authorize Drive',

        // Modal archivos
        'archivos.modal.titulo':    'Files',
        'archivos.cargando':        'Loading...',
        'archivos.btn.subir':       '↑ Upload file',
        'archivos.footer.hint':     'PDF, JPG, JFIF, PNG, ADI, LOG, TXT, ZIP, CBR, XLS, XLSX',
        'archivos.shack-visible':   'Show in Shack',
        'archivos.vacio':           'No files in this folder.',
        'archivos.btn.ver':         'View',

        // Panel perfil
        'perfil.titulo':            'Settings',
        'perfil.hint.google':       'Data synced from Google',
        'perfil.seccion.radio':     '📡 Amateur radio data',
        'perfil.campo.indicativoOp':'Operator callsign',
        'perfil.campo.indicativosEspeciales':'Special callsigns',
        'perfil.campo.indicativosEspeciales.hint':'(comma separated)',
        'perfil.campo.club':        'Club / society',
        'perfil.campo.zonaCQ':      'CQ zone',
        'perfil.campo.zonaITU':     'ITU zone',
        'perfil.seccion.prefs':     '⚙️ Preferences',
        'perfil.seccion.peligro':   '⚠️ Danger zone',
        'perfil.peligro.descripcion':'Deleting your account will permanently remove all your registered contests and files. This action cannot be undone.',
        'perfil.btn.eliminar':      'Delete my account',

        // Modal eliminar cuenta
        'cuentaelim.titulo':        'Delete account',
        'cuentaelim.subtitulo':     'This action will permanently delete all your contests and data. It cannot be undone.',
        'cuentaelim.label':         'Type DELETE to confirm:',
        'cuentaelim.placeholder':   'DELETE',
        'cuentaelim.btn.cancelar':  'Cancel',
        'cuentaelim.btn.confirmar': 'Delete everything',
        'cuentaelim.palabra':       'DELETE',

        // Toasts
        'toast.sesion.expirada':    'Session expired. Please sign in again.',
        'toast.concurso.actualizado':'Contest updated: {nombre}',
        'toast.concurso.agregado':  'Contest added: {nombre}',
        'toast.concurso.eliminado': 'Contest deleted: {nombre}',
        'toast.drive.carpetas.ok':  '📁 Folders created in Google Drive.',
        'toast.drive.carpetas.error':'Could not create Drive folders. They will be created on first upload.',
        'toast.drive.conectado':    'Drive connected successfully!',
        'toast.drive.error.conectar':'Could not connect to Drive.',
        'toast.drive.error.autorizar':'Error authorizing Drive.',
        'toast.drive.preparando':   'Preparing Drive folder...',
        'toast.drive.subiendo':     'Uploading file...',
        'toast.drive.subido':       'File uploaded: {nombre}',
        'toast.drive.error.subir':  'Error uploading file: {error}',
        'toast.drive.error.cargar': 'Error loading files.',
        'toast.perfil.guardado':    'Profile saved successfully.',
        'toast.perfil.error':       'Could not save profile.',
        'toast.cuenta.eliminada':   'Account deleted successfully.',
        'toast.cuenta.error':       'Error deleting account. Please try again.',

        // Etiquetas de tipo archivo
        'tipo.log.nombre':   'Log',          'tipo.log.icono':   '📄',
        'tipo.conf.nombre':  'QSL',          'tipo.conf.icono':  '📬',
        'tipo.res.nombre':   'Results',      'tipo.res.icono':   '📊',
        'tipo.cert.nombre':  'Certificates', 'tipo.cert.icono':  '🏆',
        'tipo.reg.nombre':   'Rules',        'tipo.reg.icono':   '📋',
        'tipo.log.desc':  'Contest log file: Cabrillo, ADIF, LOG, TXT, etc.',
        'tipo.conf.desc': 'Log receipt confirmation: email, screenshot, or file where the contest organizer confirms that your log was received correctly.',
        'tipo.res.desc':  'Official standings or results published by the organizer.',
        'tipo.cert.desc': 'Certificate or award acknowledging your participation or ranking.',
        'tipo.reg.desc':  'Official contest rules for reference.',

        // Buscador catálogo
        'catalogo.buscando':              'Searching...',
        'catalogo.sin.resultados':        '"{texto}" was not found in the catalog.',
        'catalogo.btn.solicitar':         'Request to add this contest',

        // Modal solicitud
        'solicitud.titulo':               '➕ Request new contest',
        'solicitud.descripcion':          'The contest will be reviewed and added to the catalog by the administrator.',
        'solicitud.campo.nombre':         'Contest name',
        'solicitud.campo.web':            'Website / Rules',
        'solicitud.campo.modos':          'Modes',
        'solicitud.campo.bandas':         'Bands',
        'solicitud.campo.descripcion':    'Description',
        'solicitud.placeholder.nombre':   'E.g.: CQ World Wide DX Contest',
        'solicitud.placeholder.descripcion': 'Brief contest description...',
        'solicitud.modo.mixto':           'Mixed',
        'solicitud.bandas.todas':         'All',
        'solicitud.btn.cancelar':         'Cancel',
        'solicitud.btn.enviar':           'Send request',
        'solicitud.btn.enviando':         'Sending...',
        'solicitud.toast.enviada':        'Request sent. The administrator will review it.',
        'solicitud.toast.error':          'Could not send the request. Please try again.',
        'solicitud.error.nombre':         'Name is required.',
        'solicitud.error.web':            'Please enter a valid URL.',
        'solicitud.error.modos':          'Enter at least one mode.',

        // Selector de idioma
        'idioma.selector.label':    'Language',

        // Footer
        'footer.copyright':         '© 2026 Contest Manager · Developed by CX4DPG - Uruguay · v2.0.0-beta',
        'footer.btn.sugerencia':    'Send feedback',
        'footer.btn.acercade':      'About',

        // Modal sugerencia
        'sugerencia.titulo':        '📧 Send feedback',
        'sugerencia.campo.tipo':    'Type',
        'sugerencia.tipo.sugerencia':'💡 Suggestion',
        'sugerencia.tipo.bug':      '🐛 Bug',
        'sugerencia.tipo.otro':     '💬 Other',
        'sugerencia.campo.mensaje': 'Message',
        'sugerencia.placeholder':   'Describe your suggestion or the error you found...',
        'sugerencia.btn.cancelar':  'Cancel',
        'sugerencia.btn.enviar':    '📧 Send',
        'sugerencia.error.vacio':   'Message cannot be empty.',
        'sugerencia.toast.abriendo':'Opening mail client...',

        // Modal acerca de
        'acercade.titulo':          '📋 About',
        'acercade.descripcion':     'Contest management system for amateur radio operators',
        'acercade.item1':           '🔧 Beta version — actively in development',
        'acercade.item2':           '🐛 Found a bug? Use the 📧 button to send feedback',
        'acercade.dev':             'Developed by CX4DPG — Uruguay',
        'acercade.stack':           'Stack: Firebase · Vite · JavaScript ES6',
        'acercade.copyright':       '© 2026 All rights reserved.',
        'acercade.btn.cerrar':      'Close',

        // Comunes reutilizables
        'common.guardar':           'Save',
        'common.guardando':         'Saving...',
        'common.cancelar':          'Cancel',

        // Dashboard — texto vacío por sección
        'dashboard.seccion.vacia':  'No contests in this category.',

        // Tarjeta de concurso
        'tarjeta.btn.ver-sitio':    'Visit site ↗',

        // Tarjeta de perfil — edición inline
        'tarjeta.btn.editar-perfil':                'Edit profile',
        'tarjeta.crop.titulo':                      'Crop your profile photo',
        'tarjeta.crop.confirmar':                   'Confirm crop',
        'tarjeta.placeholder.indicativo-op':        'Operator callsign',
        'tarjeta.placeholder.indicativos-esp':      'Special callsigns (comma separated)',
        'tarjeta.hint.indicativos-esp':             'You can add multiple special callsigns separated by commas.',
        'tarjeta.select.sin-qrz':                   '— No QRZ —',
        'tarjeta.select.sin-clublog':               '— No ClubLog —',
        'tarjeta.select.sin-eqsl':                  '— No eQSL —',

        // Tarjeta de perfil — ámbitos de posición
        'tarjeta.ambito.local':         'URUGUAY',
        'tarjeta.ambito.regional':      'SOUTH AMERICA',
        'tarjeta.ambito.mundial':       'WORLDWIDE',

        // Tarjeta de perfil — etiquetas meta
        'tarjeta.meta.club':            'Club',
        'tarjeta.meta.pais':            'Country / DXCC',
        'tarjeta.meta.zona-cq':         'CQ Zone',
        'tarjeta.meta.zona-itu':        'ITU Zone',
        'tarjeta.meta.qth':             'QTH',
        'tarjeta.meta.grid':            'Grid',
        'tarjeta.meta.telefono':        'Phone',
        'tarjeta.meta.correo':          'Email',
        'tarjeta.meta.enlaces':         'Links',

        // Tarjeta de perfil — estadísticas
        'tarjeta.stats.titulo':         'Activity summary',
        'tarjeta.stats.subtitulo':      'Quick overview of the operator on the platform',
        'tarjeta.stats.concursos':      'Contests',
        'tarjeta.stats.participaciones':'Participations',
        'tarjeta.stats.mejores':        'Best positions',
        'tarjeta.stats.mejor-pais':     'Best country',
        'tarjeta.stats.mejor-continente':'Best continent',
        'tarjeta.stats.mejor-mundo':    'Best worldwide',
        'tarjeta.stats.total-uno':      'contest',
        'tarjeta.stats.total-varios':   'contests',
        'tarjeta.stats.ver-mas-uno':    'Show 1 more contest',
        'tarjeta.stats.ver-mas-varios': 'Show {n} more contests',
        'tarjeta.stats.mostrar-menos':  'Show less',

        // Tarjeta de perfil — footer
        'tarjeta.footer.modo':          'Most used mode:',
        'tarjeta.footer.concurso':      'Most worked contest:',
        'tarjeta.footer.ultimo':        'Last contest:',

        // Shack
        'dashboard.btn.shack':          '📻 My Shack',
        'dashboard.shack.titulo':       'My Virtual Shack',

        // Cabrillo Analyzer
        'dashboard.btn.cabrillo':       '📊 Cabrillo Analyzer',
        'dashboard.cabrillo.titulo':    'Visually analyze a Cabrillo log by band, hour and destination.',
        'cabrillo.titulo':              'Cabrillo Analyzer',
        'cabrillo.subtitulo':           'Visually analyze a Cabrillo log by band, hour and destination.',
        'cabrillo.credito.dev':         '"Cabrillo Analyzer" is a tool developed by — XQ2OP (Tío Julio).',
        'cabrillo.credito.agradecimiento': 'Contest Manager especially thanks XQ2OP — Tío Julio, for developing this tool and generously sharing it with us for inclusion in the platform.',
        'cabrillo.selector.titulo':     'Select a contest',
        'cabrillo.selector.leyenda':    'Only contests with a file compatible with the Cabrillo Analyzer are shown. If a contest is missing, check that you uploaded its log in Cabrillo format (.log, .cbr or .txt).',
        'cabrillo.selector.cargando':   'Loading your contests…',
        'cabrillo.selector.vacio':      'You don\'t have any contests with a Cabrillo log uploaded to Contest Manager yet.',
        'cabrillo.selector.no-auth':    'Sign in to Contest Manager to see your contests.',
        'cabrillo.selector.no-auth.login': 'Sign in',
        'cabrillo.selector.btn':        'Analyze',
        'cabrillo.selector.btn.cargando': 'Analyzing…',
        'cabrillo.estado.cargando-log': 'Loading log…',
        'cabrillo.estado.error':        'This log could not be loaded automatically.',
        'cabrillo.estado.inicial':      'Select one of your contests to start the analysis.',

        // Modal concurso — sección posición
        'modal.concurso.campo.posicion':       'Position',
        'modal.concurso.campo.opcional':       '(optional)',
        'modal.concurso.posicion.local':       'Local',
        'modal.concurso.posicion.regional':    'Regional',
        'modal.concurso.posicion.mundial':     'Worldwide',
        'modal.concurso.placeholder.puesto':   'Rank',
        'modal.concurso.placeholder.pais':     'Select country...',
        'modal.concurso.placeholder.region':   'Select region...',

        // Modal concurso — errores de validación
        'modal.concurso.error.nombre':         'Contest name is required.',
        'modal.concurso.error.año':            'Enter a valid year (1990–2100).',
        'modal.concurso.error.modo':           'Select a mode.',
        'modal.concurso.error.indicativo':     'Select the callsign you participated with.',
        'modal.concurso.error.fechainicio':    'Start date is required.',
        'modal.concurso.error.fechafin':       'End date is required.',
        'modal.concurso.error.fechaorden':     'End date must be after start date.',
        'modal.concurso.error.url':            'Enter a valid URL (e.g.: https://cqww.com).',

        // Configuración — preferencias
        'perfil.campo.tema-oscuro':            'Dark theme',
        'perfil.seccion.almacenamiento':       'Storage',
        'perfil.storage.user.nombre':          'My Drive',
        'perfil.storage.user.sub':             'Personal Google Drive',
        'perfil.storage.user.t1':              'Full privacy — only you have access',
        'perfil.storage.user.t2':              'Requires connecting your Google Drive account',
        'perfil.storage.user.t3':              'Recommended for private files',
        'perfil.storage.managed.sub':          'System storage',
        'perfil.storage.managed.t1':           'No setup required — no need to connect your Drive',
        'perfil.storage.managed.t2':           'Limited space and subject to availability',
        'perfil.storage.managed.t3':           'Not recommended for sensitive files',
        'perfil.notif.activar':                'Enable notifications',
        'perfil.notif.inapp':                  'In-app',
        'perfil.notif.resultados-disp':        'Results available',
        'perfil.notif.certificados-disp':      'Certificates available',
        'perfil.notif.poremail':               'By email',
        'perfil.sesion.cerrar':                'Sign out',
        'perfil.btn.reiniciar-onboarding':     'Watch the guide again',
        'perfil.admin.titulo':                 '⚙️ Administration',
        'perfil.admin.btn':                    'Admin panel',
        'perfil.drive.conectado.texto':              '✓ Google Drive connected — click to disconnect',
        'perfil.drive.noconectado.texto':            '○ Google Drive not connected — click to connect',
        'perfil.drive.desconectar.confirma.titulo':  'Disconnect Google Drive?',
        'perfil.drive.desconectar.confirma.subtitulo': 'Access will be revoked. You can reconnect it any time.',
        'perfil.drive.desconectar.confirma.btn':       'Yes, disconnect',
        'perfil.error.almacenamiento':         'Could not save storage preference.',

        // Shack — toolbar
        'shack.toolbar.elemento':              'Element',
        'shack.toolbar.encuadrar':             '🖼️ Frame',
        'shack.toolbar.encuadrar.title':       'Edit frame and proportions of selected piece',
        'shack.toolbar.add-map':               '+ Map',
        'shack.toolbar.pared':                 'Wall',
        'shack.toolbar.borrar':                'Delete',
        'shack.toolbar.alinear':               'Align',
        'shack.toolbar.distribuir':            'Distribute',
        'shack.toolbar.orden':                 'Order',
        'shack.toolbar.frente':                'Bring to front',
        'shack.toolbar.fondo':                 'Send to back',
        'shack.toolbar.calibracion':           'Calibration',
        'shack.toolbar.guardar-cal':           'Save calib.',
        'shack.toolbar.vista':                 'View',
        'shack.toolbar.zoom-reset.title':      'Reset zoom (double-click on empty area)',
        'shack.toolbar.certs':                 'Certs',
        'shack.toolbar.gestionar-certs':       '🎖 Visible',
        'shack.toolbar.compartir':             'Share',
        'shack.toolbar.copiar-iframe':         '🔗 Copy code for QRZ',
        'shack.toolbar.copiar-iframe.title':   'Publish Shack and copy image code for QRZ.com',
        'shack.toolbar.align-left.title':      'Align to left edge',
        'shack.toolbar.align-center-h.title':  'Center horizontally',
        'shack.toolbar.align-right.title':     'Align to right edge',
        'shack.toolbar.align-top.title':       'Align to top edge',
        'shack.toolbar.align-middle.title':    'Center vertically',
        'shack.toolbar.align-bottom.title':    'Align to bottom edge',
        'shack.toolbar.distribute-h.title':    'Distribute with equal horizontal spacing',
        'shack.toolbar.distribute-v.title':    'Distribute with equal vertical spacing',
        'shack.toolbar.toggle-calib.title':    'Toggle calibration grid',
        'shack.toast.iframe-copiado':          'Shack published. Image code copied for QRZ.',
        'shack.toast.iframe-error-callsign':   'Could not detect callsign.',
        'shack.toast.iframe-error-publicar':   'Could not publish the Virtual Shack.',
        'shack.toast.iframe-error-clipboard':  'Could not copy to clipboard.',
        'shack.qrz.virtual-de':               'Virtual Shack of',
        'shack.qrz.cta':                      'Click to open the interactive Virtual Shack.',
        'shack.panel-certs.titulo':            'Certificates in Shack',
        'shack.panel-certs.vacio':             'No certificates available.',
        'shack.panel-certs.error':             'Error updating visibility.',

        // Shack — avisos y toasts
        'shack.error.cargar':                  'Error loading the shack.',
        'shack.aviso.pendientes':              'You have {n} certificate(s) to frame.',
        'shack.aviso.encuadrar':               '🖼️ Frame now',
        'shack.aviso.omitir':                  'Skip',
        'shack.toast.todos-encuadrados':       'All frames done!',
        'shack.aviso.drive.texto':             'Certificates need Google Drive access to display.',
        'shack.aviso.drive.autorizar':         'Authorize Drive',
        'shack.aviso.drive.autorizando':       'Authorizing...',
        'shack.aviso.drive.reintentar':        'Retry',
        'shack.toast.seleccionar-item':        'Select a certificate or map first.',
        'shack.toast.cuadro-actualizado':      'Frame updated.',
        'shack.toast.mapa-existe':             'Map already exists.',
        'shack.toast.mapa-agregado':           'Map added.',
        'shack.toast.cert-no-borrar':          'Certificates cannot be deleted from the shack. You can only move them.',
        'shack.toast.cert-borrado':            'Certificate permanently deleted.',
        'shack.toast.cert-error-datos':        'Cannot delete: missing file data.',
        'shack.toast.cert-error-storage':      'Error deleting from storage. The file was not removed.',
        'shack.toast.cert-error-firestore':    'Error deleting the record. Check the file status.',

        // Encuadrador
        'encuadrador.titulo':                  '🖼️ Frame certificate',
        'encuadrador.toolbar.alinear':         'Align cert:',
        'encuadrador.toolbar.centrar-h':       'Center horizontally',
        'encuadrador.toolbar.centrar-v':       'Center vertically',
        'encuadrador.toolbar.centrar-hv':      'Center in frame',
        'encuadrador.toolbar.ajustar':         'Fit to frame',
        'encuadrador.toolbar.quitar-crop':     'Remove crop',
        'encuadrador.marco.label':             'Frame',
        'encuadrador.proporcion.label':        'Frame ratio',
        'encuadrador.btn.cancelar':            'Cancel',
        'encuadrador.btn.guardar':             '✓ Save frame',
        'encuadrador.error.pdf':               'Could not preview this PDF',
        'encuadrador.cargando':                'Loading...',
        'encuadrador.modelo.negro':            'Black',
        'encuadrador.modelo.madera':           'Wood',
        'encuadrador.aspecto.libre':           'Free',

        // Public view controls
        'tarjeta.vista-publica.titulo':       'Public view',
        'tarjeta.vista-publica.idioma':       'Card language',
        'tarjeta.vista-publica.tema':         'Card theme',
        'tarjeta.vista-publica.lang.es':      'Spanish',
        'tarjeta.vista-publica.lang.en':      'English',
        'tarjeta.vista-publica.tema.light':   'Light',
        'tarjeta.vista-publica.tema.dark':    'Dark',
        'tarjeta.vista-publica.ver':          'View public card',
        'tarjeta.vista-publica.opciones':     'Options',

        // QRZ profile card
        'tarjeta.btn.copiar-iframe':    'Copy card for QRZ',
        'tarjeta.iframe.aria-info':     'About the QRZ profile card',
        'tarjeta.iframe.tooltip.p1':    'This code displays your Contest Manager profile card on other pages, like the QRZ Biography section or any other website.',
        'tarjeta.iframe.tooltip.p2':    'Just copy and paste it wherever you want your profile card to appear.',
        'tarjeta.iframe.tooltip.p3':    'Your profile information updates automatically whenever you save changes in Contest Manager.',
        'tarjeta.toast.iframe.copiado': 'Card copied. Paste it in the Biography section on QRZ. Updates appear automatically.',
        'tarjeta.toast.iframe.error':   'Could not copy the code.',

        // Botón onboarding
        'perfil.btn.reiniciar-onboarding': 'Watch the guide again',

        // Login — divisor
        'login.divisor.o':              'or',

        // Campos de perfil sin i18n previo
        'perfil.campo.pais':            'Country / DXCC',
        'perfil.campo.qth':             'QTH',
        'perfil.campo.grid':            'Grid Locator',
        'perfil.campo.dxcc':            'DXCC',
        'perfil.campo.telefono':        'Phone',
        'perfil.campo.correo-contacto': 'Contact email',
        'perfil.campo.qrz':             'QRZ',
        'perfil.mostrar-telefono':      'Show phone publicly',
        'perfil.mostrar-correo':        'Show email publicly',

        // Shack spinner
        'shack.cargando-certificados':  'Loading certificates...',

        // Shack quick guide
        'shack.guia.titulo':            'Quick guide:',
        'shack.guia.p1':               'Select certificate',
        'shack.guia.p2':               'Frame if needed',
        'shack.guia.p3':               'Move or adjust position',
        'shack.guia.p4':               'Save changes',
        'shack.guia.p5':               'Copy code for QRZ',
        'shack.guia.cerrar.aria':       'Close guide',

        // Shack — publish confirmation
        'shack.confirma.publicar.titulo':    'Publish Shack and copy code for QRZ?',
        'shack.confirma.publicar.subtitulo': 'Images will be uploaded and your Shack will be visible on your public profile. You can update it at any time.',
        'shack.confirma.publicar.btn':       'Yes, publish',

        // Modal archivos — acciones sobre ítems
        'archivos.btn.preview':         'Preview',
        'archivos.btn.abrir':           'Open in Drive',
        'archivos.btn.eliminar-archivo':'Delete file',
        'archivos.confirmar.titulo':    'Delete this file?',
        'archivos.confirmar.subtitulo': 'It will be removed from Drive and the registry.',
        'archivos.toast.eliminado':     'File deleted successfully.',

        // Modal drive — autorización
        'drive.autorizando':            'Authorizing...',
        'drive.subiendo':               'Uploading...',
        'toast.drive.error.autorizar2': 'Could not authorize Google Drive. You can try again.',
        'toast.drive.error.cargar2':    'Could not load the files. You can try again.',
        'toast.drive.error.eliminar':   'Could not delete the file. You can try again.',
        'toast.drive.auth.requerida':   'Authorize Google Drive before uploading. Click "Authorize Google Drive".',
        'toast.drive.sesion-requerida': 'You must be signed in to use this storage.',

        // Errores de Drive por código
        'toast.drive.sesion-expirada':  'Your Google Drive session expired. Re-authorize and try again.',
        'toast.drive.no-autorizado':    'Google Drive is not authorized in this session. Authorize it to continue.',
        'toast.drive.acceso-revocado':  'Google Drive access was revoked. You must authorize again.',
        'toast.drive.sin-permisos':     'Missing Google Drive permissions. Re-authorize and try again.',
        'toast.drive.desconectado':          'Google Drive disconnected successfully.',
        'toast.drive.error.desconectar':     'Could not disconnect Google Drive. Please try again.',
        'toast.drive.error.generico':   'An error occurred with Google Drive.',
        'toast.drive.error.fallback':   'You can try again.',

        // Perfil — modales de almacenamiento y cuenta
        'perfil.storage.labels.user':       'My Drive (Personal Google Drive)',
        'perfil.storage.labels.managed':    'Contest Manager',
        'perfil.storage.cambio.descripcion':'You have files stored in "{from}". To switch to "{to}", the administrator must migrate your files first.',
        'perfil.acceso-managed.enviado':    'Request sent. The administrator will review it shortly.',
        'perfil.acceso-managed.error':      'Could not send the request. Please try again.',
        'perfil.acceso-managed.btn':        'Request access',
        'perfil.cambio-storage.enviado':    'Change request sent. The administrator will review it shortly.',
        'perfil.cambio-storage.btn':        'Request change',
        'perfil.eliminando':                'Deleting...',
        'perfil.enviando':                  'Sending...',
        'perfil.cuenta.subtitulo-drive':    'This action will delete your account, profile, contests, shack, and the Google Drive structure created by the app. If any Drive resource cannot be deleted, we will inform you clearly.',
        'perfil.cuenta.subtitulo-nodrive':  'This action will delete your account, profile, contests, and shack. Files in Google Drive created by the app will not be deleted because there is no active Drive authorization.',
        'perfil.cuenta.eliminada-drive-omitido': 'Account deleted. Internal data was removed, but Google Drive resources were not deleted because there was no active authorization.',
        'perfil.cuenta.eliminada-drive-errores': 'Account deleted. Internal data was removed, but some Google Drive resources could not be deleted.',
        'perfil.cuenta.relogin-requerido':  'Your internal data has been processed, but Firebase requires you to sign in again before completing the final account deletion.',

        // Progreso de eliminación de cuenta
        'perfil.cuenta.progreso.preparando':        'Preparing account deletion...',
        'perfil.cuenta.progreso.drive-sin-auth':     'Internal data deleted. Drive resources were not removed because there was no active authorization.',
        'perfil.cuenta.progreso.drive-sin-recursos': 'No Drive resources to delete.',
        'perfil.cuenta.progreso.eliminando-acceso':  'Removing account access...',

        // Auth — mensajes de login/sesión
        'auth.recuperar.email-requerido':   'Enter your email first.',
        'auth.recuperar.enviado':           'We sent you an email to reset your password.',
        'auth.sesion.cerrada':              'Signed out successfully.',
        'auth.sesion.error-cerrar':         'Error signing out.',

        // Auth — errores de Firebase
        'auth.error.popup-cerrado':         'You closed the window before completing sign-in.',
        'auth.error.popup-bloqueado':       'The browser blocked the popup. Allow it and try again.',
        'auth.error.popup-cancelado':       'Sign-in request was cancelled.',
        'auth.error.red':                   'Network error. Check your connection.',
        'auth.error.muchos-intentos':       'Too many attempts. Please wait a few minutes.',
        'auth.error.email-en-uso':          'An account with that email already exists.',
        'auth.error.email-invalido':        'The email address is not valid.',
        'auth.error.contrasena-debil':      'Password must be at least 6 characters.',
        'auth.error.usuario-no-encontrado': 'No account found with that email.',
        'auth.error.contrasena-incorrecta': 'Incorrect password.',
        'auth.error.credencial-invalida':   'Incorrect email or password.',
        'auth.error.generico':              'Authentication error:',

        // Help Center
        'ayuda.titulo':             'Help Center',
        'ayuda.subtitulo':          'Quick guides for using Contest Manager and its integrations.',
        'ayuda.volver':             'Back to app',
        'ayuda.reiniciar-onboarding': 'Show Getting Started guide again',
        'ayuda.grupo.qrz':      'QRZ integrations',
        'ayuda.a1.titulo':      'How to add my profile card to QRZ',
        'ayuda.a1.p1':          'Sign in to Contest Manager.',
        'ayuda.a1.p2':          'Make sure your public profile is complete.',
        'ayuda.a1.p3':          'On your profile card, click "Copy card for QRZ".',
        'ayuda.a1.p4':          'Go to QRZ.com.',
        'ayuda.a1.p5':          'Open Edit [your callsign] → Biography.',
        'ayuda.a1.p6':          'Paste the copied code into the HTML editor.',
        'ayuda.a1.p7':          'Save your changes.',
        'ayuda.a1.nota':        'Note: The profile card updates automatically when your information or contest activity changes in Contest Manager.',
        'ayuda.a2.titulo':      'How to add my Virtual Shack to QRZ',
        'ayuda.a2.intro':       'QRZ does not allow the interactive Virtual Shack to run directly inside the Biography because it blocks external scripts. Contest Manager instead generates an auto-updating image that opens the full interactive Shack when clicked.',
        'ayuda.a2.p1':          'Sign in to Contest Manager.',
        'ayuda.a2.p2':          'Open "My Virtual Shack".',
        'ayuda.a2.p3':          'Arrange your certificates.',
        'ayuda.a2.p4':          'Click "Copy code for QRZ".',
        'ayuda.a2.p5':          'Go to QRZ.com.',
        'ayuda.a2.p6':          'Open Edit [your callsign] → Biography.',
        'ayuda.a2.p7':          'Paste the copied code into the HTML editor.',
        'ayuda.a2.p8':          'Save your changes.',
        'ayuda.a2.nota':        'Note: The Shack image shown on QRZ updates automatically when you modify your Virtual Shack. Clicking the image opens the full interactive Shack.',

        // Help Center — section 1: Getting started
        'ayuda.s1.titulo':  'Getting started',
        'ayuda.s1.texto':   'Start by setting up your account, callsign and public profile.',
        'ayuda.s1.p1':      'Sign in to Contest Manager.',
        'ayuda.s1.p2':      'Log in with your account.',
        'ayuda.s1.p3':      'Complete your profile with callsign, name, country, grid and public information.',
        'ayuda.s1.p4':      'Review your public profile view.',
        'ayuda.s1.p5':      'Start registering your contest participations.',

        // Help Center — section 2: Public profile
        'ayuda.s2.titulo':  'Public profile',
        'ayuda.s2.texto':   'Your public profile shows your main amateur radio information and a summary of your activity.',
        'ayuda.s2.b1':      'You can show your callsign, name, country, grid, zones, club and external links.',
        'ayuda.s2.b2':      'You can choose which contact details to show or hide.',
        'ayuda.s2.b3':      'The public profile card updates automatically when your information or contest activity changes.',
        'ayuda.s2.b4':      'You can display your profile card on QRZ or other websites by copying the code from your Contest Manager profile.',

        // Help Center — section 3: Contests and files
        'ayuda.s3.titulo':  'Contests and files',
        'ayuda.s3.texto':   'Contest Manager organizes your participations and files by contest, year and mode.',
        'ayuda.s3.b1':      'Register each participation with contest, year, mode and dates.',
        'ayuda.s3.b2':      'Upload files such as logs, confirmations, results, certificates and rules.',
        'ayuda.s3.b3':      'Some files may remain pending moderation before being shown publicly.',
        'ayuda.s3.b4':      'Contests are organized as In progress, Upcoming and Finished.',
        'ayuda.s3.b5':      'Finished contests are sorted with the most recent ones first.',

        // Help Center — section 4: Virtual Shack
        'ayuda.s4.titulo':  'Virtual Shack',
        'ayuda.s4.texto':   'The Virtual Shack lets you display your certificates inside a visual scene.',
        'ayuda.s4.b1':      'You can move certificates, adjust their position and organize your virtual wall.',
        'ayuda.s4.b2':      'Use the mouse wheel to zoom.',
        'ayuda.s4.b3':      'Drag with the left mouse button to move around the scene.',
        'ayuda.s4.b4':      'Double-click a certificate to view it in detail.',
        'ayuda.s4.b5':      'If you delete a certificate from the Shack, it is permanently removed from Contest Manager and the associated storage.',
        'ayuda.s4.b6':      'Visible certificates can also be shown on your public Virtual Shack page.',

        // Help Center — section 6: Storage
        'ayuda.s6.titulo':  'Storage',
        'ayuda.s6.texto':   'Contest Manager can work with files stored in your own Drive or with platform-managed storage.',
        'ayuda.s6.b1':      'In personal Drive mode, files are stored in your Google Drive account.',
        'ayuda.s6.b2':      'In CM Storage mode, files are stored in Contest Manager\'s managed storage.',
        'ayuda.s6.b3':      'Access to CM Storage may require administrator approval.',
        'ayuda.s6.b4':      'Files used in QRZ or shown publicly may be stored in the platform storage to ensure they load correctly.',
        'ayuda.s6.b5':      'Do not share sensitive files if you do not want them to appear publicly.',

        // Help Center — section 7: Notifications
        'ayuda.s7.titulo':  'Notifications',
        'ayuda.s7.texto':   'Contest Manager uses in-app notifications and, in some cases, email notifications.',
        'ayuda.s7.b1':      'You may receive alerts when a request is approved or rejected.',
        'ayuda.s7.b2':      'The administrator may receive alerts for new requests.',
        'ayuda.s7.b3':      'Notifications appear in the bell icon in the top bar.',
        'ayuda.s7.b4':      'Some important actions may also be sent by email.',

        // Help Center — section 8: FAQ
        'ayuda.s8.titulo':  'Frequently asked questions',
        'ayuda.s8.q1':      'Why does my Shack not appear interactively inside QRZ?',
        'ayuda.s8.a1':      'Because QRZ does not allow external scripts inside its pages. Contest Manager instead uses a static image that opens the full interactive Shack when clicked.',
        'ayuda.s8.q2':      'Does the Shack image on QRZ update automatically?',
        'ayuda.s8.a2':      'Yes. When you modify your Virtual Shack, Contest Manager updates the public image used in QRZ.',
        'ayuda.s8.q3':      'Do I need to copy the QRZ code again every time I change my Shack?',
        'ayuda.s8.a3':      'No. You only need to copy it again if you want to replace the code on your QRZ page.',
        'ayuda.s8.q4':      'Does the profile card update automatically?',
        'ayuda.s8.a4':      'Yes. The card uses your public data and activity registered in Contest Manager.',
        'ayuda.s8.q5':      'Are my original files public?',
        'ayuda.s8.a5':      'Not necessarily. For QRZ, Contest Manager uses a public image prepared to display the Shack, not the original certificate file.',
        'ayuda.s8.q6':      'What happens if I delete a certificate from the Shack?',
        'ayuda.s8.a6':      'The certificate is permanently deleted from Contest Manager, the Virtual Shack and the associated storage. This action cannot be undone.',

        // Getting started
        'primeros-pasos.titulo':    '🚀 Getting started',
        'primeros-pasos.cerrar':    'Dismiss',
        'primeros-pasos.p1.titulo': 'Complete your profile',
        'primeros-pasos.p1.desc':   'Add your callsign, CQ/ITU zone and station details.',
        'primeros-pasos.p2.titulo': 'Choose your storage',
        'primeros-pasos.p2.desc':   'Set up your own Google Drive or platform-managed storage.',
        'primeros-pasos.p3.titulo': 'Register your first contest',
        'primeros-pasos.p3.desc':   'Add the name, dates and operating mode.',
        'primeros-pasos.p4.titulo': 'Upload your files',
        'primeros-pasos.p4.desc':   'After registering a contest you can attach log, confirmation, results, certificate and rules.',
        'primeros-pasos.p5.titulo': 'Explore your public profile',
        'primeros-pasos.p5.desc':   'Opens your public page with your callsign, stats and contest activity.',
        'primeros-pasos.p6.titulo': 'Discover the Virtual Shack',
        'primeros-pasos.p6.desc':   'Organize and display your certificates in a 3D scene.',
    },
};

// ── Estado del módulo ─────────────────────────────────────────

/** Idioma activo. Se inicializa desde Firestore o localStorage. */
let _idioma = 'es';
let _bootstrapFueExplicito = false;

// ── API pública ───────────────────────────────────────────────

/**
 * Devuelve la traducción para la clave dada.
 * Soporta interpolación: t('toast.concurso.agregado', { nombre: 'CQ WW' })
 * @param {string} clave
 * @param {Object} [vars] - Variables para interpolación
 * @returns {string}
 */
export function t(clave, vars = {}) {
    const diccionario = TRADUCCIONES[_idioma] ?? TRADUCCIONES.es;
    let texto = diccionario[clave] ?? TRADUCCIONES.es[clave] ?? clave;

    // Interpolación: reemplaza {variable} con el valor correspondiente
    for (const [nombre, valor] of Object.entries(vars)) {
        texto = texto.replaceAll(`{${nombre}}`, valor);
    }

    return texto;
}

/**
 * Devuelve el idioma activo actualmente.
 * @returns {'es'|'en'}
 */
export function idiomaActual() {
    return _idioma;
}

/**
 * Cambia el idioma activo y aplica las traducciones al DOM.
 * Persiste la elección en localStorage para uso inmediato.
 * La sincronización con Firestore la hace el llamador.
 *
 * @param {'es'|'en'} nuevoIdioma
 */
export function cambiarIdioma(nuevoIdioma) {
    if (!TRADUCCIONES[nuevoIdioma]) {
        console.warn(`[i18n] Idioma desconocido: "${nuevoIdioma}". Se mantiene "${_idioma}".`);
        return;
    }
    _idioma = nuevoIdioma;
    localStorage.setItem('idioma', nuevoIdioma);
    aplicarIdioma();
    actualizarSelectorIdioma();
}

/**
 * Inicializa el idioma desde Firestore (preferencia guardada)
 * o desde localStorage como fallback. Aplica al DOM.
 *
 * @param {'es'|'en'|null} idiomaGuardado - Viene del perfil de Firestore
 */
export function inicializarIdioma(idiomaGuardado = null) {
    // 1. URL param — highest priority, works across origins
    const urlLang = new URLSearchParams(location.search).get('lang');
    if (urlLang && TRADUCCIONES[urlLang]) {
        localStorage.setItem('idioma', urlLang);
        history.replaceState(null, '', location.pathname + location.hash);
    }

    // 2. Explicit home-page selection (same-origin fallback)
    const idiomaHomeSelection = localStorage.getItem('idioma_home_selection');
    if (idiomaHomeSelection) {
        localStorage.setItem('idioma', idiomaHomeSelection);
        localStorage.removeItem('idioma_home_selection');
    }

    const idiomaLocal = localStorage.getItem('idioma');
    _idioma = (urlLang && TRADUCCIONES[urlLang] ? urlLang : null)
           ?? idiomaHomeSelection
           ?? idiomaGuardado
           ?? idiomaLocal
           ?? 'es';
    // Track whether this call resolved a language from an explicit source
    // (URL param, home selection, or localStorage) vs fell back to 'es'.
    // Auth uses this to decide whether Firestore should override the app.
    _bootstrapFueExplicito = !!(urlLang || idiomaHomeSelection || idiomaLocal);
    localStorage.setItem('idioma', _idioma);
    aplicarIdioma();
    actualizarSelectorIdioma();
}

export function bootstrapFueExplicito() { return _bootstrapFueExplicito; }

// ── Aplicación al DOM ─────────────────────────────────────────

/**
 * Recorre todos los elementos con data-i18n y reemplaza su contenido.
 * También actualiza placeholders (data-i18n-placeholder)
 * y atributos title (data-i18n-title).
 */
export function aplicarIdioma() {
    const diccionario = TRADUCCIONES[_idioma] ?? TRADUCCIONES.es;

    // Texto interno
    document.querySelectorAll('[data-i18n]').forEach(el => {
        const clave = el.dataset.i18n;
        const texto = diccionario[clave] ?? TRADUCCIONES.es[clave] ?? clave;
        el.textContent = texto;
    });

    // Placeholder de inputs
    document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
        const clave = el.dataset.i18nPlaceholder;
        el.placeholder = diccionario[clave] ?? TRADUCCIONES.es[clave] ?? clave;
    });

    // Atributo title
    document.querySelectorAll('[data-i18n-title]').forEach(el => {
        const clave = el.dataset.i18nTitle;
        el.title = diccionario[clave] ?? TRADUCCIONES.es[clave] ?? clave;
    });

    // Atributo aria-label
    document.querySelectorAll('[data-i18n-aria]').forEach(el => {
        const clave = el.dataset.i18nAria;
        el.setAttribute('aria-label', diccionario[clave] ?? TRADUCCIONES.es[clave] ?? clave);
    });

    // Actualizar lang del html
    document.documentElement.lang = _idioma;

    // Notificar a componentes JS que re-renderizan por su cuenta
    document.dispatchEvent(new CustomEvent('idioma:cambio', { detail: { idioma: _idioma } }));
}

/**
 * Fuerza un idioma para la vista actual sin escribir en localStorage.
 * Usada por páginas públicas (/u/, /embed/) para mostrar el idioma del propietario.
 * @param {'es'|'en'} idioma
 */
export function forzarIdioma(idioma) {
    if (!TRADUCCIONES[idioma]) return;
    _idioma = idioma;
    aplicarIdioma();
}

/**
 * Sincroniza el estado visual del selector ES|EN del navbar.
 */
function actualizarSelectorIdioma() {
    const btnEs = document.getElementById('btn-idioma-es');
    const btnEn = document.getElementById('btn-idioma-en');
    if (!btnEs || !btnEn) return;

    btnEs.classList.toggle('idioma-selector__btn--activo', _idioma === 'es');
    btnEn.classList.toggle('idioma-selector__btn--activo', _idioma === 'en');
}